import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=4ec396a6&scoped=true&"
import script from "./Summary.vue?vue&type=script&lang=ts&"
export * from "./Summary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec396a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec396a6')) {
      api.createRecord('4ec396a6', component.options)
    } else {
      api.reload('4ec396a6', component.options)
    }
    module.hot.accept("./Summary.vue?vue&type=template&id=4ec396a6&scoped=true&", function () {
      api.rerender('4ec396a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Summary.vue"
export default component.exports